import { render, staticRenderFns } from "./noticeList.vue?vue&type=template&id=a981335e&scoped=true&"
import script from "./noticeList.vue?vue&type=script&lang=js&"
export * from "./noticeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a981335e",
  null
  
)

component.options.__file = "noticeList.vue"
export default component.exports